"use client"

import { use } from "react"
import { AuthContext, type AuthContextValue } from "@/contexts/AuthContext"

export function useAuth(): AuthContextValue {
  const context = use(AuthContext)
  if (!context) {
    throw new Error("useAuth() должен вызываться внутри AuthProvider")
  }
  return context
}
